import Vue from 'vue';
import { Commit } from 'vuex';
import { PollingState } from '@/utils/types/store';
import apiConfig from '@/config/api';
import log from '@/utils/log';

export interface ResponseTransformer<T> {
  (data: object | object[]): T | T[];
}

const axios = {
  get: (commit: Commit) => <T>(
    route: string,
    mutation: string,
    transformer?: ResponseTransformer<T>,
  ): Promise<void> => Vue
      .axios
      .get(route)
      .then((result) => result.data)
      .then((data: object | object[]) => (transformer ? transformer(data) : data))
      .then((data) => {
        commit(mutation, data);
      })
      .catch((error) => {
        throw new Error(`API ${error}`);
      }),
};

const polling = {
  check: (shouldPoll: boolean, state: PollingState, fn: Function): number | undefined => {
    if (shouldPoll && state.pollingIntervalId === undefined) {
      log.debug('Begin polling');
      return setInterval(fn, apiConfig.polling.interval);
    }
    if (!shouldPoll && state.pollingIntervalId) {
      log.debug('Stop polling');
      clearInterval(state.pollingIntervalId);
      return undefined;
    }
    log.debug(state.pollingIntervalId === undefined ? 'Not polling' : 'Keep polling');
    return state.pollingIntervalId;
  },
};

export default {
  axios,
  polling,
};
